module.exports = ({
    "CDMS101P001": "กรุณากรอกอีเมล",
    "CDMS101P002": "กรุณากรอกคำตอบเพื่อความปลอดภัยของคุณ",
    "CDMS101MSG001": "กรุณากรอกอีเมล",
    "CDMS101MSG002": "อีเมลยังไม่ได้ถูกลงทะเบียน",
    "CDMS101MSG003": "กรุณาระบุคำตอบสำหรับคำถามความปลอดภัย",
    "CDMS101MSG004": "คำถามความปลอดภัยที่คุณเลือกไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
    "CDMS101MSG005": "รหัสผ่านของคุณได้รับการรีเซ็ตแล้ว รหัสผ่านใหม่ได้ถูกส่งไปยังอีเมลของคุณแล้ว",
    "CDMS101BTN001": "รีเซ็ต",
    "CDMS101LB001": "อีเมล",
    "CDMS101LB002": "เลือกคําถามและคําตอบความปลอดภัย",
    "CDMS101LB003": "คำถามความปลอดภัย",
    "CDMS101LB004": "คำตอบความปลอดภัย",
    "CDMS101TT001": "ลืมรหัสผ่าน",
    "CDMS102TT001": "ลืมรหัสผู้ใช้งาน",
    "CDMS102TT002": "ลืมรหัสผู้ใช้งาน",
    "CDMS102MSG001": "รหัสผู้ใช้งานได้ถูกส่งไปยังอีเมล์แล้ว",
    "CDMS102BTN001": "ส่ง",
    "COMBTN025": "กลับเข้าสู่ระบบ"
});